import moment from "moment-timezone";
import { isListNotEmpty, isNotNullOrUndefined, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";

export const updateObject = (oldObject, updatedValues) => {
    return {
        ...oldObject,
        ...updatedValues
    };
};

export const addObjectToTop = (oldObjects, newObject) => {
    return [newObject, ...oldObjects];
};

export const addObjectToBottom = (oldObjects, newObject) => {
    return [...oldObjects, newObject];
};

export const addRecordToTop = (state, newRecord) => {
    // check to see if record already exists in the state, update if so, insert if not
    const copyOfState = { ...state };
    let existingList = [...copyOfState.records];
    const index = existingList.findIndex(obj => obj.id === newRecord.id);
    let updatedRecords = [];
    // only update if the record exists in the list
    if (index !== -1) {
        updatedRecords = [
            ...existingList.slice(0, index), // everything before current obj
            newRecord,
            ...existingList.slice(index + 1), // everything after current obj
        ];
    } else {
        updatedRecords = addObjectToTop(existingList, newRecord);
    }

    return updateObject(state, {
        records: updatedRecords
    });
};

export const addRecordToBottom = (state, newRecord) => {
    // check to see if record already exists in the state, update if so, insert if not
    const copyOfState = { ...state };
    let existingList = [...copyOfState.records];
    const index = existingList.findIndex(obj => obj.id === newRecord.id);
    let updatedRecords = [];
    // only update if the record exists in the list
    if (index !== -1) {
        updatedRecords = [
            ...existingList.slice(0, index), // everything before current obj
            newRecord,
            ...existingList.slice(index + 1), // everything after current obj
        ];
    } else {
        updatedRecords = addObjectToBottom(existingList, newRecord);
    }

    return updateObject(state, {
        records: updatedRecords
    });
};

export const updateRecordInList = (state, updatedRecord) => {
    const copyOfState = { ...state };
    let existingList = [...copyOfState.records];
    const index = existingList.findIndex(obj => obj.id === updatedRecord.id);

    // only update if the record exists in the list
    if (index !== -1) {
        const updatedRecords = [
            ...existingList.slice(0, index), // everything before current obj
            updatedRecord,
            ...existingList.slice(index + 1), // everything after current obj
        ];

        return updateObject(state, {
            records: updatedRecords
        });
    } else {
        return state;
    }
};

export const updateSingleRecord = (state, updatedRecord) => {
    // only update if the record matches what is in the state
    const copyOfState = { ...state };
    const existingObject = isObjectNotEmpty(copyOfState.record) ? { ...copyOfState.record } : null;
    if (isObjectNotEmpty(existingObject) && existingObject.id === updatedRecord.id) {
        return updateObject(state, {
            record: updatedRecord
        });
    } else {
        return state;
    }
};

export const removeRecordFromList = (state, recordToRemove) => {
    const copyOfState = { ...state };
    let existingList = [...copyOfState.records];
    const index = existingList.findIndex(obj => obj.id === recordToRemove.id);

    // only update if the record exists in the list
    if (index !== -1) {
        // returns the deleted items
        existingList.splice(index, 1);

        return updateObject(state, {
            records: existingList
        });
    } else {
        return state;
    }
};

export const updateStateStart = (state) => {
    return updateObject(state, {
        isLoading: true,
        error: null
    });
};

export const updateStateSuccess = (state, action) => {
    return updateObject(state, {
        ...action,
        isLoading: false,
        error: null
    });
};

export const resetState = (state, initialState) => {
    return updateObject(state, {
        ...initialState
    });
};

export const updateStateFailure = (state, action) => {
    return updateObject(state, {
        error: action.error,
        isLoading: false
    });
};

export const fetchRecordsStart = (state) => {
    return updateObject(state, {
        isLoadingRecords: true,
        errorRecords: null
    });
};

export const fetchRecordsSuccess = (state, action) => {
    return updateObject(state, {
        ...action,
        isLoadingRecords: false,
        errorRecords: null
    });
};

export const resetRecords = (state) => {
    return updateObject(state, {
        records: []
    });
};

export const fetchRecordsFail = (state, action) => {
    return updateObject(state, {
        errorRecords: action.error,
        isLoadingRecords: false
    });
};

export const fetchRecordStart = (state) => {
    return updateObject(state, {
        isLoadingRecord: true,
        errorRecord: null
    });
};

export const fetchRecordSuccess = (state, action) => {
    return updateObject(state, {
        ...action,
        errorRecord: null,
        isLoadingRecord: false
    });
};

export const resetRecord = (state) => {
    return updateObject(state, {
        record: null
    });
};

export const fetchRecordFail = (state, action) => {
    return updateObject(state, {
        errorRecord: action.error,
        isLoadingRecord: false
    });
};

export const createRecordStart = (state) => {
    return updateObject(state, {
        isLoadingCreate: true,
        errorCreate: null
    });
};

export const createRecordSuccess = (state, action) => {
    return updateObject(state, {
        isLoadingCreate: false,
        errorCreate: null,
        newRecord: action.newRecord
    });
};

export const createRecordFail = (state, action) => {
    return updateObject(state, {
        errorCreate: action.error,
        isLoadingCreate: false,
        newRecord: null
    });
};

export const resetCreateRecord = (state) => {
    return updateObject(state, {
        isLoadingCreate: null,
        errorCreate: null,
        newRecord: null
    });
};

export const updateRecordStart = (state) => {
    return updateObject(state, {
        isLoadingUpdate: true,
        errorUpdate: null
    });
};

export const updateRecordSuccess = (state, action) => {
    return updateObject(state, {
        isLoadingUpdate: false,
        errorUpdate: null,
        updatedRecord: action.newRecord
    });
};

export const updateRecordFail = (state, action) => {
    return updateObject(state, {
        errorUpdate: action.error,
        isLoadingUpdate: false,
        updatedRecord: null
    });
};

export const resetUpdateRecord = (state) => {
    return updateObject(state, {
        isLoadingUpdate: null,
        errorUpdate: null,
        updatedRecord: null
    });
};

export const deleteRecordStart = (state) => {
    return updateObject(state, {
        isLoadingDelete: true,
        errorDelete: null
    });
};

export const deleteRecordSuccess = (state) => {
    return updateObject(state, {
        isLoadingDelete: false,
        errorDelete: null
    });
};

export const deleteRecordFail = (state, action) => {
    return updateObject(state, {
        errorDelete: action.error,
        isLoadingDelete: false
    });
};

export const resetDeleteRecord = (state) => {
    return updateObject(state, {
        errorDelete: null,
        isLoadingDelete: null
    });
};

export const newPaginatedList = {
    displayName: null,
    pages: [],
    records: [],
    searchParams: {},
    pagination: { totalCount: 0, currentPage: 1, pageSize: 100, totalPages: 1 },
    isLoading: false,
    error: null
};

export const newList = {
    records: [],
    isLoading: false,
    error: null,
    lastUpdatedAt: null
};

export const newPage = {
    pageNumber: 1,
    pageSize: 100,
    prevLastItem: null,
    firstItem: null,
    lastItem: null,
    records: []
}

export const fetchListStart = (state, action) => {
    const copyOfState = { ...state };
    let existingLists = { ...copyOfState.lists };
    let newLists = {};

    if (isStringNotEmpty(action.listName)) {
        if (isObjectNotEmpty(existingLists[action.listName])) {
            newLists[action.listName] = {
                ...existingLists[action.listName],
                isLoading: true,
                error: null
            };
        } else {
            newLists[action.listName] = {
                ...newList,
                isLoading: true,
                error: null
            };
        }
    }

    return updateObject(state, {
        lists: { ...existingLists, ...newLists }
    });
};

export const fetchListSuccess = (state, action) => {
    const copyOfState = { ...state };
    let existingLists = { ...copyOfState.lists };
    let newLists = {};

    if (isStringNotEmpty(action.listName)) {
        if (isObjectNotEmpty(existingLists[action.listName])) {
            newLists[action.listName] = {
                ...existingLists[action.listName],
                isLoading: false,
                error: null,
                lastUpdatedAt: moment()
            };

            if (isNotNullOrUndefined(action.records)) {
                newLists[action.listName].records = [...action.records];
            }
        } else {
            newLists[action.listName] = {
                ...newList,
                isLoading: false,
                error: null,
                lastUpdatedAt: moment()
            };

            if (isNotNullOrUndefined(action.records)) {
                newLists[action.listName].records = [...action.records];
            }
        }
    }

    return updateObject(state, {
        lists: { ...existingLists, ...newLists }
    });
};

export const fetchListFail = (state, action) => {
    const copyOfState = { ...state };
    let existingLists = { ...copyOfState.lists };
    let newLists = {};

    if (isStringNotEmpty(action.listName)) {
        if (isObjectNotEmpty(existingLists[action.listName])) {
            newLists[action.listName] = {
                ...existingLists[action.listName],
                isLoading: false,
                error: null
            };

            if (isNotNullOrUndefined(action.error)) {
                newLists[action.listName].error = action.error;
            }
        } else {
            newLists[action.listName] = {
                ...newList,
                isLoading: false,
                error: null
            };

            if (isNotNullOrUndefined(action.error)) {
                newLists[action.listName].error = action.error;
            }
        }
    }

    return updateObject(state, {
        lists: { ...existingLists, ...newLists }
    });
};

export const addToTopOfList = (state, action) => {
    if (isObjectNotEmpty(action.newRecord) && isStringNotEmpty(action.listName)) {
        const copyOfState = { ...state };
        let existingLists = { ...copyOfState.lists };
        let newLists = {};

        if (isObjectNotEmpty(existingLists[action.listName])) {
            let existingList = isListNotEmpty(existingLists[action.listName].records) ? [...existingLists[action.listName].records] : [];
            const index = existingList.findIndex(obj => obj.id === action.newRecord.id);

            // only add the record if it doesn't exist in the list already
            if (index === -1) {
                newLists[action.listName] = {
                    ...existingLists[action.listName],
                    records: [action.newRecord, ...existingLists[action.listName].records]
                };

                newLists[action.listName].pagination.total = newLists[action.listName].pagination.total + 1;
            } else {
                const updatedRecords = [
                    ...existingList.slice(0, index), // everything before current obj
                    action.newRecord,
                    ...existingList.slice(index + 1), // everything after current obj
                ];

                newLists[action.listName] = {
                    ...existingLists[action.listName],
                    records: [...updatedRecords]
                };
            }
        } else {
            newLists[action.listName] = {
                ...newList,
                records: [action.newRecord]
            };

            newLists[action.listName].pagination.total = newLists[action.listName].pagination.total + 1;
        }

        return updateObject(state, {
            lists: { ...existingLists, ...newLists }
        });
    }

    return state;
};

export const addToBottomOfList = (state, action) => {
    if (isObjectNotEmpty(action.newRecord) && isStringNotEmpty(action.listName)) {
        const copyOfState = { ...state };
        let existingLists = { ...copyOfState.lists };
        let newLists = {};

        if (isObjectNotEmpty(existingLists[action.listName])) {
            let existingList = isListNotEmpty(existingLists[action.listName].records) ? [...existingLists[action.listName].records] : [];
            const index = existingList.findIndex(obj => obj.id === action.newRecord.id);

            // only add the record if it doesn't exist in the list already
            if (index === -1) {
                newLists[action.listName] = {
                    ...existingLists[action.listName],
                    records: [...existingLists[action.listName].records, action.newRecord]
                };

                newLists[action.listName].pagination.total = newLists[action.listName].pagination.total + 1;
            } else {
                const updatedRecords = [
                    ...existingList.slice(0, index), // everything before current obj
                    action.newRecord,
                    ...existingList.slice(index + 1), // everything after current obj
                ];

                newLists[action.listName] = {
                    ...existingLists[action.listName],
                    records: [...updatedRecords]
                };
            }
        } else {
            newLists[action.listName] = {
                ...newList,
                records: [action.newRecord]
            };

            newLists[action.listName].pagination.total = newLists[action.listName].pagination.total + 1;
        }

        return updateObject(state, {
            lists: { ...existingLists, ...newLists }
        });
    }

    return state;
};

export const addToTopOfLists = (state, action) => {
    if (isObjectNotEmpty(action.newRecord)) {
        const copyOfState = { ...state };
        let existingLists = { ...copyOfState.lists };
        let newLists = {};

        if (isObjectNotEmpty(existingLists['ALL'])) {
            let existingList = isListNotEmpty(existingLists['ALL'].records) ? [...existingLists['ALL'].records] : [];
            const index = existingList.findIndex(obj => obj.id === action.newRecord.id);

            // only add the record if it doesn't exist in the list already
            if (index === -1) {
                newLists['ALL'] = {
                    ...existingLists['ALL'],
                    records: [action.newRecord, ...existingLists['ALL'].records]
                };

                newLists['ALL'].pagination.total = newLists['ALL'].pagination.total + 1;
            } else {
                const updatedRecords = [
                    ...existingList.slice(0, index), // everything before current obj
                    action.newRecord,
                    ...existingList.slice(index + 1), // everything after current obj
                ];

                newLists['ALL'] = {
                    ...existingLists['ALL'],
                    records: [...updatedRecords]
                };
            }
        } else {
            newLists['ALL'] = {
                ...newList,
                records: [action.newRecord]
            };

            newLists['ALL'].pagination.total = newLists['ALL'].pagination.total + 1;
        }

        if (isStringNotEmpty(action.listName)) {
            if (isObjectNotEmpty(existingLists[action.listName])) {
                let existingList = isListNotEmpty(existingLists[action.listName].records) ? [...existingLists[action.listName].records] : [];
                const index = existingList.findIndex(obj => obj.id === action.newRecord.id);

                // only add the record if it doesn't exist in the list already
                if (index === -1) {
                    newLists[action.listName] = {
                        ...existingLists[action.listName],
                        records: [action.newRecord, ...existingLists[action.listName].records]
                    };

                    newLists[action.listName].pagination.total = newLists[action.listName].pagination.total + 1;
                } else {
                    const updatedRecords = [
                        ...existingList.slice(0, index), // everything before current obj
                        action.newRecord,
                        ...existingList.slice(index + 1), // everything after current obj
                    ];

                    newLists[action.listName] = {
                        ...existingLists[action.listName],
                        records: [...updatedRecords]
                    };
                }
            } else {
                newLists[action.listName] = {
                    ...newList,
                    records: [action.newRecord]
                };

                newLists[action.listName].pagination.total = newLists[action.listName].pagination.total + 1;
            }
        }

        return updateObject(state, {
            lists: { ...existingLists, ...newLists }
        });
    }

    return state;
};

export const addToBottomOfLists = (state, action) => {
    if (isObjectNotEmpty(action.newRecord)) {
        const copyOfState = { ...state };
        let existingLists = { ...copyOfState.lists };
        let newLists = {};

        if (isObjectNotEmpty(existingLists['ALL'])) {
            let existingList = isListNotEmpty(existingLists['ALL'].records) ? [...existingLists['ALL'].records] : [];
            const index = existingList.findIndex(obj => obj.id === action.newRecord.id);

            // only add the record if it doesn't exist in the list already
            if (index === -1) {
                newLists['ALL'] = {
                    ...existingLists['ALL'],
                    records: [...existingLists['ALL'].records, action.newRecord]
                };

                newLists['ALL'].pagination.total = newLists['ALL'].pagination.total + 1;
            } else {
                const updatedRecords = [
                    ...existingList.slice(0, index), // everything before current obj
                    action.newRecord,
                    ...existingList.slice(index + 1), // everything after current obj
                ];

                newLists['ALL'] = {
                    ...existingLists['ALL'],
                    records: [...updatedRecords]
                };
            }
        } else {
            newLists['ALL'] = {
                ...newList,
                records: [action.newRecord]
            };

            newLists['ALL'].pagination.total = newLists['ALL'].pagination.total + 1;
        }

        if (isStringNotEmpty(action.listName)) {
            if (isObjectNotEmpty(existingLists[action.listName])) {
                let existingList = isListNotEmpty(existingLists[action.listName].records) ? [...existingLists[action.listName].records] : [];
                const index = existingList.findIndex(obj => obj.id === action.newRecord.id);

                // only add the record if it doesn't exist in the list already
                if (index === -1) {
                    newLists[action.listName] = {
                        ...existingLists[action.listName],
                        records: [...existingLists[action.listName].records, action.newRecord]
                    };

                    newLists[action.listName].pagination.total = newLists[action.listName].pagination.total + 1;
                } else {
                    const updatedRecords = [
                        ...existingList.slice(0, index), // everything before current obj
                        action.newRecord,
                        ...existingList.slice(index + 1), // everything after current obj
                    ];

                    newLists[action.listName] = {
                        ...existingLists[action.listName],
                        records: [...updatedRecords]
                    };
                }
            } else {
                newLists[action.listName] = {
                    ...newList,
                    records: [action.newRecord]
                };

                newLists[action.listName].pagination.total = newLists[action.listName].pagination.total + 1;
            }
        }

        return updateObject(state, {
            lists: { ...existingLists, ...newLists }
        });
    }

    return state;
};

export const updateInList = (state, action) => {
    if (isObjectNotEmpty(action.updatedRecord) && isStringNotEmpty(action.listName)) {
        const copyOfState = { ...state };
        let existingLists = { ...copyOfState.lists };
        let newLists = {};

        if (isObjectNotEmpty(existingLists[action.listName])) {
            let existingList = isListNotEmpty(existingLists[action.listName].records) ? [...existingLists[action.listName].records] : [];
            const index = existingList.findIndex(obj => obj.id === action.updatedRecord.id);

            // only update if the record exists in the list
            if (index !== -1) {
                const updatedRecords = [
                    ...existingList.slice(0, index), // everything before current obj
                    action.updatedRecord,
                    ...existingList.slice(index + 1), // everything after current obj
                ];

                newLists[action.listName] = {
                    ...existingLists[action.listName],
                    records: [...updatedRecords]
                };
            }
        }

        if (isObjectNotEmpty(newLists)) {
            return updateObject(state, {
                lists: { ...existingLists, ...newLists }
            });
        }
    }

    return state;
};

export const updateInLists = (state, action) => {
    if (isObjectNotEmpty(action.updatedRecord)) {
        const copyOfState = { ...state };
        let existingLists = { ...copyOfState.lists };
        let newLists = {};

        if (isObjectNotEmpty(existingLists['ALL'])) {
            let existingList = isListNotEmpty(existingLists['ALL'].records) ? [...existingLists['ALL'].records] : [];
            const index = existingList.findIndex(obj => obj.id === action.updatedRecord.id);

            // only update if the record exists in the list
            if (index !== -1) {
                const updatedRecords = [
                    ...existingList.slice(0, index), // everything before current obj
                    action.updatedRecord,
                    ...existingList.slice(index + 1), // everything after current obj
                ];

                newLists['ALL'] = {
                    ...existingLists['ALL'],
                    records: [...updatedRecords]
                };
            }
        }

        if (isStringNotEmpty(action.listName) && isObjectNotEmpty(existingLists[action.listName])) {
            let existingList = isListNotEmpty(existingLists[action.listName].records) ? [...existingLists[action.listName].records] : [];
            const index = existingList.findIndex(obj => obj.id === action.updatedRecord.id);

            // only update if the record exists in the list
            if (index !== -1) {
                const updatedRecords = [
                    ...existingList.slice(0, index), // everything before current obj
                    action.updatedRecord,
                    ...existingList.slice(index + 1), // everything after current obj
                ];

                newLists[action.listName] = {
                    ...existingLists[action.listName],
                    records: [...updatedRecords]
                };
            }
        }

        if (isObjectNotEmpty(newLists)) {
            return updateObject(state, {
                lists: { ...existingLists, ...newLists }
            });
        }
    }

    return state;
};

export const removeFromList = (state, action) => {
    if (isObjectNotEmpty(action.recordToRemove) && isStringNotEmpty(action.listName)) {
        const copyOfState = { ...state };
        let existingLists = { ...copyOfState.lists };
        let newLists = {};

        if (isObjectNotEmpty(existingLists[action.listName])) {
            let existingList = isListNotEmpty(existingLists[action.listName].records) ? [...existingLists[action.listName].records] : [];
            const index = existingList.findIndex(obj => obj.id === action.recordToRemove.id);

            // only update if the record exists in the list
            if (index !== -1) {
                existingList.splice(index, 1);

                newLists[action.listName] = {
                    ...existingLists[action.listName],
                    records: [...existingList]
                };

                newLists[action.listName].pagination.total = newLists[action.listName].pagination.total > 0 ? newLists[action.listName].pagination.total - 1 : 0;
            }
        }

        if (isObjectNotEmpty(newLists)) {
            return updateObject(state, {
                lists: { ...existingLists, ...newLists }
            });
        }
    }

    return state;
};

export const removeFromLists = (state, action) => {
    if (isObjectNotEmpty(action.recordToRemove)) {
        const copyOfState = { ...state };
        let existingLists = { ...copyOfState.lists };
        let newLists = {};

        if (isObjectNotEmpty(existingLists['ALL'])) {
            let existingList = isListNotEmpty(existingLists['ALL'].records) ? [...existingLists['ALL'].records] : [];
            const index = existingList.findIndex(obj => obj.id === action.recordToRemove.id);

            // only update if the record exists in the list
            if (index !== -1) {
                existingList.splice(index, 1);

                newLists['ALL'] = {
                    ...existingLists['ALL'],
                    records: [...existingList]
                };

                newLists['ALL'].pagination.total = newLists['ALL'].pagination.total > 0 ? newLists['ALL'].pagination.total - 1 : 0;
            }
        }

        if (isStringNotEmpty(action.listName) && isObjectNotEmpty(existingLists[action.listName])) {
            let existingList = isListNotEmpty(existingLists[action.listName].records) ? [...existingLists[action.listName].records] : [];
            const index = existingList.findIndex(obj => obj.id === action.recordToRemove.id);

            // only update if the record exists in the list
            if (index !== -1) {
                existingList.splice(index, 1);

                newLists[action.listName] = {
                    ...existingLists[action.listName],
                    records: [...existingList]
                };

                newLists[action.listName].pagination.total = newLists[action.listName].pagination.total > 0 ? newLists[action.listName].pagination.total - 1 : 0;
            }
        }

        if (isObjectNotEmpty(newLists)) {
            return updateObject(state, {
                lists: { ...existingLists, ...newLists }
            });
        }
    }

    return state;
};

export const resetList = (state, action) => {
    if (isStringNotEmpty(action.listName)) {
        const copyOfState = { ...state };
        let existingLists = { ...copyOfState.lists };
        let newLists = {};

        newLists[action.listName] = {
            ...newList
        };

        return updateObject(state, {
            lists: { ...existingLists, ...newLists }
        });
    }

    return state;
};

export const resetAllLists = (state) => {
    return updateObject(state, {
        lists: {}
    });
};

export const selectListRecords = (lists, filter) => {
    if (isObjectNotEmpty(lists)) {
        if (isStringNotEmpty(filter)) {
            if (isObjectNotEmpty(lists[filter])) {
                return lists[filter].records;
            }
        }
    }

    return newList.records;
};

export const selectListIsLoading = (lists, filter) => {
    if (isObjectNotEmpty(lists)) {
        if (isStringNotEmpty(filter)) {
            if (isObjectNotEmpty(lists[filter])) {
                return lists[filter].isLoading;
            }
        }
    }

    return newList.isLoading;
};

export const selectListError = (lists, filter) => {
    if (isObjectNotEmpty(lists)) {
        if (isStringNotEmpty(filter)) {
            if (isObjectNotEmpty(lists[filter])) {
                return lists[filter].error;
            }
        }
    }

    return newList.error;
};

export const selectListLastUpdatedAt = (lists, filter) => {
    if (isObjectNotEmpty(lists)) {
        if (isStringNotEmpty(filter)) {
            if (isObjectNotEmpty(lists[filter])) {
                return lists[filter].lastUpdatedAt;
            }
        }
    }

    return newList.lastUpdatedAt;
};

export const selectListSearchParams = (lists, filter) => {
    if (isObjectNotEmpty(lists)) {
        if (isStringNotEmpty(filter)) {
            if (isObjectNotEmpty(lists[filter])) {
                return lists[filter].searchParams;
            }
        }
    }

    return newList.searchParams;
};

export const selectListPagination = (lists, filter) => {
    if (isObjectNotEmpty(lists)) {
        if (isStringNotEmpty(filter)) {
            if (isObjectNotEmpty(lists[filter])) {
                return lists[filter].pagination;
            }
        }
    }

    return newList.pagination;
};